

import React, { useState } from 'react';
import './../style.scss';
import { FormattedMessage } from 'react-intl';
import { InputText } from 'components';
import { Button } from 'react-bootstrap';

const regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{6,22}$/

const ForgotPassword = ({ otp, setOtp, newPassword, setNewPassword, renewPassword,
  setRenewPassword, changePassword, intl }) => {

  const [errorMsg, setErrorMsg] = useState('');
  const [errorMsg2, setErrorMsg2] = useState('');
  const [errorMsg3, setErrorMsg3] = useState('');

  const handleOTP = (value) => {
    if (!value) {
      setErrorMsg(intl.formatMessage({ id: 'IDS_VALIDATION_VPLUS_USERNAME_LENGTH' }));
    } else {
      setErrorMsg('');
    }
    setOtp(value);
  }

  const handleNewPassword = (value) => {
    setNewPassword(value);
    if (!regexPassword.test(value)) {
      setErrorMsg2(intl.formatMessage({ id: 'IDS_PASSWORD_IS_NOT_VALID' }));
    } else {
      setErrorMsg2('');
    }
    if (renewPassword && renewPassword !== value) {
      setErrorMsg3(intl.formatMessage({ id: 'IDS_TV_PASSWORD_NOT_MATCH' }));
    } else {
      setErrorMsg3('');
    }
  }

  const handleRePassword = (value) => {
    setRenewPassword(value)
    if (newPassword !== value) {
      setErrorMsg3(intl.formatMessage({ id: 'IDS_TV_PASSWORD_NOT_MATCH' }));
    } else {
      setErrorMsg3('');
    }
  }

  const checkValid = () => {
    const msg = intl.formatMessage({ id: 'IDS_VALIDATION_VPLUS_USERNAME_LENGTH' });
    let valid = true;
    if (!otp) {
      setErrorMsg(msg);
      valid = false;
    }
    if (!newPassword) {
      setErrorMsg2(msg);
      valid = false;
    }
    if (!newPassword) {
      setErrorMsg3(msg);
      valid = false;
    }
    return valid;
  }

  const handleConfirm = () => {
    if (checkValid()) {
      changePassword();
    }
  }

  const validPassword = () => {
    if (!newPassword || !renewPassword || newPassword !== renewPassword || errorMsg || errorMsg2 || errorMsg3) {
      return false;
    }
    return true;
  }

  const isDisabled = () => {
    return !otp || !validPassword();
  }

  return (
    <div className="login__confirm">
      <InputText
        value={otp}
        handleOnChange={handleOTP}
        placeholder={intl.formatMessage({ id: 'IDS_TV_FORM_OTP' })}
        errorMsg={errorMsg}
        onlyNumber
      />
      <InputText
        value={newPassword}
        handleOnChange={handleNewPassword}
        placeholder={intl.formatMessage({ id: 'IDS_SNEWPASSWORD' })}
        errorMsg={errorMsg2}
        customClass="mt-3"
        isPassword
      />
      <InputText
        value={renewPassword}
        handleOnChange={handleRePassword}
        placeholder={intl.formatMessage({ id: 'IDS_SRENEWPASSWORD' })}
        errorMsg={errorMsg3}
        customClass="mt-3"
        isPassword
      />
      <div className="login__notice-password"><FormattedMessage id='IDS_NOTICE_PASS' /></div>

      <Button className="login__btn" disabled={isDisabled()} onClick={handleConfirm}>
        <FormattedMessage id='IDS_TV_XAC_NHAN' />
      </Button>
    </div>
  );
}

export default React.memo(ForgotPassword);

